import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24" style={{ backgroundColor: "var(--ink)", color: "var(--bone)" }}>
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif text-3xl">
            <span style={{ color: "var(--avt-teal)" }}>Add</span>
            <span style={{ color: "var(--avt-purple)" }}>Vend</span>
            <span style={{ color: "var(--avt-orange)" }}>Tour</span>
          </div>
          <p className="mt-2 text-sm" style={{ color: "var(--avt-pink)" }}>
            Add your event. Book vendors. Discover more.
          </p>
          <p className="mt-4 text-sm opacity-70 leading-relaxed max-w-sm">
            Where local makers meet the events that matter. Curated, community-driven, and gloriously handmade.
          </p>
        </div>
        <div>
          <div className="overline opacity-70 mb-4" style={{ color: "var(--avt-teal)" }}>For Vendors</div>
          <ul className="space-y-2 text-sm opacity-90" data-testid="footer-vendor-features">
            <li>Find events near you</li>
            <li><Link to="/vendtrade" data-testid="footer-vendtrade" className="underline hover:opacity-100 opacity-90">VendTrade barter marketplace</Link></li>
            <li>Build your portfolio + AI logo studio</li>
            <li>Track applications & booth payments</li>
            <li>7-day free Maker Pro trial</li>
            <li>AI business co-founder chat</li>
            <li>Bookkeeping + Schedule C exports</li>
            <li>Receipt AI + mileage log</li>
            <li>Sales tax tracker by jurisdiction</li>
            <li>Cash-flow forecast</li>
            <li>QR code + customer reviews</li>
            <li>Success Score dashboard</li>
            <li>Book Now inquiries inbox</li>
            <li>Refer-a-friend rewards</li>
            <li>Public @handle profile page</li>
          </ul>
        </div>
        <div>
          <div className="overline opacity-70 mb-4" style={{ color: "var(--avt-orange)" }}>For Organizers</div>
          <ul className="space-y-2 text-sm opacity-90" data-testid="footer-organizer-features">
            <li>Post one-off or recurring events</li>
            <li>Review & approve vendor applications</li>
            <li>Collect booth fees via Stripe Connect</li>
            <li>AI-suggested vendors for your event</li>
            <li>AI flyer studio + social share</li>
            <li>Weather, attendance & revenue predictions</li>
            <li>20-item planning checklist</li>
            <li>Waitlist with manual promotion</li>
            <li>Auto vendor booth contracts (PDF)</li>
            <li>Edit + cancel with automatic refunds</li>
            <li>Event recap photo gallery</li>
            <li>Bidirectional post-event ratings</li>
            <li>Verified organizer badge</li>
            <li>Trust & safety moderation tools</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-8 text-xs opacity-60">
        <div className="mx-auto max-w-4xl px-6 text-center leading-relaxed" data-testid="footer-disclaimer">
          <span className="uppercase tracking-widest opacity-80">Fine print · </span>
          We are not responsible for canceled events as we are not associated with any event organizer unless stated.
          We are not responsible for any scammers that may slip through our procedural checks or bad event turn outs.
          <div className="mt-3 flex justify-center gap-6 text-[11px] uppercase tracking-widest">
            <Link to="/nonprofits" data-testid="footer-nonprofits" className="underline hover:opacity-100 opacity-90 inline-flex items-center gap-1">
              ♥ Nonprofits
            </Link>
            <Link to="/terms" data-testid="footer-terms" className="underline hover:opacity-100 opacity-90">Terms</Link>
            <Link to="/privacy" data-testid="footer-privacy" className="underline hover:opacity-100 opacity-90">Privacy</Link>
            <Link to="/contact" data-testid="footer-contact" className="underline hover:opacity-100 opacity-90">Contact admin</Link>
          </div>
        </div>
        <div className="mt-6 text-center">© {new Date().getFullYear()} AddVendTour. Handcrafted with care.</div>
      </div>
    </footer>
  );
}
